import { PlaceDetailsResult, Predictions } from '../interfaces';

export function predictionsMock(): Predictions {
  return {
    predictions: [
      {
        description: '79 Madison Avenue, New York, NY, USA',
        placeId: 'ChIJQfCgt6dZwokRKWqi2FIAj4I',
      },
    ],
  };
}

export function placeDetailsMock(): PlaceDetailsResult {
  return {
    result: {
      addressComponents: [
        {
          longName: '45',
          shortName: '45',
          types: ['street_number'],
        },
        {
          longName: 'Bond Street',
          shortName: 'Bond St',
          types: ['route'],
        },
        {
          longName: 'Manhattan',
          shortName: 'Manhattan',
          types: ['sublocality_level_1', 'sublocality', 'political'],
        },
        {
          longName: 'New York',
          shortName: 'New York',
          types: ['locality', 'political'],
        },
        {
          longName: 'New York County',
          shortName: 'New York County',
          types: ['administrative_area_level_2', 'political'],
        },
        {
          longName: 'New York',
          shortName: 'NY',
          types: ['administrative_area_level_1', 'political'],
        },
        {
          longName: 'United States',
          shortName: 'US',
          types: ['country', 'political'],
        },
        {
          longName: '10012',
          shortName: '10012',
          types: ['postal_code'],
        },
        {
          longName: '2486',
          shortName: '2486',
          types: ['postal_code_suffix'],
        },
      ],
      formattedAddress: '45 Bond St, New York, NY 10012, USA',
      geometry: {
        location: {
          lat: 40.7258569,
          lng: -73.99308060000001,
        },
      },
      placeId: 'ChIJuYrnPoVZwokR2OdDM1Pl6t4',
    },
  };
}
